import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LinkIcon from '@mui/icons-material/Link';
import {Avatar, Button, ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material';
import React, {useState} from 'react';
import {Maybe} from '../../__generated__/resolvers-types';
import {HelpTutorialEnum} from '../../variables/helpTutorial';
import HelpButtonWrapper from '../helpButton/HelpButtonWrapper';

export interface AccountDropdownListItemPhoto {
  photoURL?: Maybe<string>;
}

export type AccountDropdownListItem = ({label: string} | {name: string}) & AccountDropdownListItemPhoto;

interface AccountDropdownButtonProps<T extends AccountDropdownListItem> {
  items: T[];
  selectedItem?: T;
  setSelectedItem: (s: T) => void;
  onLink: () => void;
}

export default function AccountDropdownButton<T extends AccountDropdownListItem>({
  items,
  onLink,
  selectedItem,
  setSelectedItem,
}: AccountDropdownButtonProps<T>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAccountSelect = (item: T) => {
    setSelectedItem(item);
    handleClose();
  };

  const handleLinkAccount = () => {
    onLink();
    handleClose();
  };

  function extractItem(d?: T) {
    return d ? (d as any).label || (d as any).name : undefined;
  }

  function btnName(accounts: T[], account: T | undefined) {
    if (accounts.length === 0) {
      return 'Link Account';
    }
    return extractItem(account) || 'Select Account';
  }
  return (
    <>
      <HelpButtonWrapper helpTutorialEnum={HelpTutorialEnum.ETSY_LINK_ACCOUNT}>
        <Button onClick={handleClick} endIcon={<ArrowDropDownIcon />} variant="contained" color="primary">
          {btnName(items, selectedItem)}
        </Button>
      </HelpButtonWrapper>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'account-button',
        }}
      >
        {items.map((item) => (
          <MenuItem key={extractItem(item) || item.photoURL} onClick={() => handleAccountSelect(item)}>
            {item.photoURL && <Avatar src={item.photoURL} sx={{mr: 2}} />}
            {extractItem(item)}
          </MenuItem>
        ))}
        <MenuItem onClick={handleLinkAccount}>
          <ListItemIcon>
            <LinkIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Link Account</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
